import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { Navigate } from "react-router-dom";
import { useCanApproveHours } from "../../../routes/roleOnly";
import { useTranslation } from "react-i18next";
import { HoursApprovalList } from "../../../components/dashboard/hours/hours_approval_list";

export const HoursApproval = () => {
  const { t } = useTranslation();
  const canApproveHours = useCanApproveHours();

  if (!canApproveHours) {
    return <Navigate to="/dashboard/hours" replace />;
  }

  return (
    <DashboardHeader
      title={t("Godkjenning av timer")}
      subtitle={t("Se og behandle timeregistreringer")}
    >
      <div className="min-h-screen bg-gray-50 p-4">
        <HoursApprovalList />
      </div>
    </DashboardHeader>
  );
};
